<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="form" :rules="rules" ref="form" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="登录账号" prop="loginId">
              <el-input :disabled="!!userId" v-model="form.loginId" placeholder="请输入登录账号" /> </el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入姓名" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <!-- <el-input v-model="form.password" type="password" placeholder="请输入密码"/> -->
              <span>默认密码是手机号后六位</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="form.mobile" maxlength="11" placeholder="请输入手机号" /> </el-form-item></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="角色" prop="roleId" placeholder="请选择角色">
              <el-select v-model="form.roleId">
                <el-option :label="item.roleName" :value="item.roleId" v-for="(item, index) of roles"
                  :key="index"></el-option>
              </el-select> </el-form-item></el-col>

          <el-col :span="12">
            <el-form-item label="业务员" prop="serviceUser" placeholder="请选择业务员">
              <el-select v-model="form.serviceUser">
                <el-option :label="item.userName" :value="item.userId" v-for="(item, index) of userList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12"> </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="form.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if='!userId' :span="24">
          <el-col :span="24">
            <el-form-item label="成品油信息" prop="">
              <div class="flex-end">
                <el-button type="primary" @click="onAdd">新增</el-button>
              </div>

              <el-table class="table-form" :data="form.inventoryList" style="width: 100%; margin-bottom: 14px">

                <el-table-column prop="" label="成品油类型" min-width="150">
                  <template v-slot="{ $index }">
                    <el-form-item label=" " :prop="'inventoryList.' + $index + '.oilType'" label-width="0" :rules="[
                      {
                        required: true,
                        message: '请选择储油类型',
                        trigger: 'change',
                      },
                    ]">
                      <!-- <el-select v-model="form.inventoryList[$index].ygType" filterable>
                        <el-option :value="item.dicCode" :label="item.dicValue" v-for="(item, index) of typeList"
                          :key="index"></el-option>
                      </el-select> -->
                      <el-select v-model="form.inventoryList[$index].oilType" filterable>
                        <el-option :value="item.oilType" :label="item.oilTypeName" v-for="(item, index) of typeList"
                          :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="每日/单价" min-width="150">
                  <template v-slot="{ $index }">
                    <el-form-item label="" :prop="'inventoryList.' + $index + '.unitPrice'" label-width="0" :rules="[
                      {
                        required: true,
                        message: '请输入每日/单价',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input-number v-model="form.inventoryList[$index].unitPrice" :min="0"
                        :max="99999999"></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="开始计价日期" min-width="150">
                  <template v-slot="{ $index }">
                    <el-form-item label="" :prop="'inventoryList.' + $index + '.ygDate'" label-width="0" :rules="[
                      {
                        required: true,
                        message: '请选择开始计价日期',
                        trigger: 'change',
                      },
                    ]">
                      <el-date-picker v-model="form.inventoryList[$index].ygDate" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd" type="date" placeholder="请选择开始计价日期">
                      </el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="单位" min-width="150">
                  <template v-slot="{ $index }">
                    <el-form-item label=" " :prop="'inventoryList.' + $index + '.ygUnit'" label-width="0" :rules="[
                      {
                        required: true,
                        message: '请选择单位',
                        trigger: 'change',
                      },
                    ]">
                      <el-select v-model="form.inventoryList[$index].ygUnit" filterable>
                        <el-option :value="item.dicCode" :label="item.dicValue" v-for="(item, index) of unitList"
                          :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="合同金额" min-width="150">
                  <template v-slot="{ $index }">
                    <el-form-item label="" :prop="'inventoryList.' + $index + '.ygPrice'" label-width="0" :rules="[
                      {
                        required: true,
                        message: '请输入合同金额',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input-number v-model="form.inventoryList[$index].ygPrice" :min="0"
                        :max="99999999"></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="数量" min-width="150">
                  <template v-slot="{ $index }">
                    <el-form-item label="" :prop="'inventoryList.' + $index + '.ygNumber'" label-width="0" :rules="[
                      {
                        required: true,
                        message: '请输入数量',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input-number v-model="form.inventoryList[$index].ygNumber" :min="0"
                        :max="99999999"></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column prop="" label="操作" width="100" fixed="right">
                  <template v-slot="{ $index }">
                    <el-button type="text" @click="onDel($index)" class="del-btn">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'YgUserAdd',
  data() {
    return {
      userList: [],
      inventoryList: [],
      typeList: [],
      roles: [],
      unitList: [],
      form: {
        loginId: '', // 登录账号
        mobile: '', // 手机号
        roleId: '', // 用户角色
        password: '', // 密码
        deptId: '1',
        userName: '',
        userType: '2',
        serviceUser: '',
        inventoryList: [],
        fileList: []
        // ygId: '',
        // ygType: '',
        // unitPrice: '',
        // ygDate: '',
        // ygPrice: ''

      },
      rules: {
        loginId: [{ required: true, message: '请输入登录账号', trigger: ['change', 'blur'] }],
        userName: [{ required: true, message: '请输入姓名', trigger: ['change', 'blur'] }],
        roleId: [{ required: true, message: '请选择角色', trigger: ['change', 'blur'] }],

        mobile: [{ required: true, message: '请输入手机号', trigger: ['change', 'blur'] },
          {
            pattern: /^1[3-9]\d{9}$/, // 手机号正则校验
            message: '请输入有效的手机号',
            trigger: ['change', 'blur']
          }],
        serviceUser: [{ required: true, message: '请选择业务员', trigger: 'change' }]
        // oilType: [{ required: true, message: '请选择成品油类型', trigger: 'blur' }]
        // ygId: [{ required: true, message: '请选择油罐', trigger: 'change' }],
        // ygType: [{ required: true, message: '请选择储油类型', trigger: 'change' }],
        // ygDate: [{ required: true, message: '请选择开始计价日期', trigger: 'change' }],
        // unitPrice: [{ required: true, message: '请输入每日/单价', trigger: 'blur' }],
        // ygPrice: [{ required: true, message: '请输入合同金额', trigger: 'blur' }]

      }
    }
  },
  computed: {
    userId() {
      return this.$route.query.userId
    },
    user() {
      return this.$store.state.user
    },
    unitData() {
      return this.$store.state.unitList
    }
  },
  created() {
    this.loadType()
    this.loadRoles()
    this.loadOliTypeList()

    if (this.userId) {
      this.loadDetails()
    }
  },
  methods: {
    onAdd() {
      this.form.inventoryList.push({
        ygNumber: '',
        oilType: '',
        unitPrice: '',
        ygDate: '',
        ygPrice: '',
        ygUnit: ''
      })
      console.log(' this.form.inventoryList: ', this.form.inventoryList)
    },
    loadRoles() {
      this.$axios.get(this.$apis.system.selectSysRoleByList).then(res => {
        this.roles = res
      })
    },
    onDel(index) {
      console.log('index: ', index)
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.inventoryList.splice(index, 1)
      })
    },
    loadOliTypeList() {
      this.$axios.get(this.$apis.oiltabkManage.selectYgOilTypeByPage).then(res => {
        this.typeList = res.list
      })
    },
    loadType() {
      // 储油类型
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'ygUnit' }
      }).then(res => {
        // this.typeList = res.ygType || []
        this.unitList = res.ygUnit || []
      })

      // 油罐
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
        this.inventoryList = res.list || []
      })

      // 关联用户
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '1',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.system.selectSysUserByUserId, {
        params: { userId: this.userId }
      }).then(res => {
        res.inventoryList = res.inventoryList || []
        this.form = res
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        if (this.form.inventoryList.length <= 0 && !this.userId) {
          this.$message.warning('请新增成品油信息')
          return
        }
        let url = this.$apis.system.insertSysUser
        if (this.userId) {
          url = this.$apis.system.updateSysUser
        }

        this.$axios.post(url, this.form).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    },

    loadDepts() {
      this.$axios.get(this.$apis.system.selectSysDeptByList).then(res => {
        this.depts = res
      })
    },
    closeCascader() {
      this.$refs.cascader.dropDownVisible = false
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'userType' }
      }).then(res => {
        this.userType = res.userType
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
